import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError} from "rxjs/operators";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {of} from "rxjs";

export const returnToLoginInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if(err.status === 401){
        router.navigate(["/login"]);
      }
      throw err;
    })
  );
};
